import { Plus, Clock } from "lucide-react";
import { fmtMoney } from "./plazaLib";
import { imgSrc } from "@/lib/dszImage";

const COLS = [
  { key: "title", label: "Product", sortable: true },
  { key: "brand", label: "Brand", sortable: true },
  { key: "category", label: "Category", sortable: false },
  { key: "price", label: "Price", sortable: true },
  { key: "rrp", label: "RRP", sortable: false },
  { key: "availability", label: "Stock", sortable: true },
  { key: "add", label: "", sortable: false },
];

export default function ProductListTable({ products, sortBy, sortDir, onSort, onOpen, onAdd }) {
  const arrow = (k) => (sortBy === k ? (sortDir === "asc" ? " ▲" : " ▼") : "");
  return (
    <div className="hpz-list-wrap" data-testid="plaza-product-list">
      <table className="hpz-list">
        <thead>
          <tr>
            {COLS.map((c) => (
              <th
                key={c.key}
                className={c.sortable ? "sortable" : ""}
                onClick={c.sortable ? () => onSort(c.key) : undefined}
                data-testid={`plaza-sort-${c.key}`}
              >{c.label}{arrow(c.key)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {products.map((p) => {
            const price = p.selling_price_cents || p.rrp_cents || 0;
            const img = imgSrc(p, 0);
            const pre = p.availability === "preorder";
            return (
              <tr key={p.sku} onClick={() => onOpen(p.sku)} data-testid={`plaza-row-${p.sku}`}>
                <td className="hpz-list__prod">
                  {img ? <img src={img} alt="" loading="lazy" /> : <span className="hpz-list__noimg" />}
                  <span className="hpz-list__title">{p.title}</span>
                </td>
                <td>{p.brand && p.brand !== "Does not apply" ? p.brand : "—"}</td>
                <td className="hpz-list__cat">
                  {((p.category_path || p.category_name || "").split(">").pop() || "").trim() || "—"}
                </td>
                <td className="hpz-list__price">${fmtMoney(price)}</td>
                <td className="hpz-list__rrp">
                  {p.rrp_cents && p.rrp_cents > price ? `$${fmtMoney(p.rrp_cents)}` : "—"}
                </td>
                <td>
                  {pre
                    ? <span className="hpz-list__pre"><Clock size={11} /> {p.restock_eta_iso?.slice(0, 10) || "Preorder"}</span>
                    : <span className="hpz-list__stock">In stock</span>}
                </td>
                <td>
                  <button
                    className="hpz-list__add"
                    onClick={(e) => { e.stopPropagation(); onAdd(p); }}
                    data-testid={`plaza-list-add-${p.sku}`}
                  ><Plus size={13} /> Add</button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
